import type { CmsExternalServiceLink } from '@gov-nx/api';

export const isSmartForm = (link: CmsExternalServiceLink) =>
	link.link.startsWith('?') && link.link.includes('formId=');
